module.exports = __webpack_public_path__ + "img/2.cleaned_toilet.f28b225a.svg";